// The key the Docs Room files a document under. Kept module-level so shared UI (the email composer)
// can scope the library to the open deal without every call site threading it through.
const slug = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const dealKeyOf = (dealId, M) => (M && M.dealKey) || dealId || `name-${slug(M && M.dealName)}`;

let current = "";
export const setCurrentDealKey = (k) => { current = k || ""; };
export const currentDealKey = () => current;
